import { InternshipsService } from './../../service/internships.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from '../../service/alert.service';
import { CompanyService } from '../../service/company.service';
import { AddInternshipDialogComponent } from '../add-internship-dialog/add-internship-dialog.component';
import { AvailableInternship } from '../../models/availableInternship.models';
import { Router } from '@angular/router';
import { Internship } from '../../models/internship';
import { ConfirmationnDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { CityDto, CountryDto } from '../../models/company.model';
import { MatIcon } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-available-internship-dialog',
  standalone: true,
  templateUrl: './view-available-internship-dialog.component.html',
  styleUrl: './view-available-internship-dialog.component.css',
  imports: [MatIcon, MatFormFieldModule, MatSelectModule, MatAutocompleteModule, MatInputModule, FormsModule, CommonModule, TranslateModule]
})
export class ViewAvailableInternshipDialogComponent implements OnInit {
  isEditable: boolean = false; 
  countries: CountryDto[] = [];
  filteredCities: CityDto[] = [];
  citySearch: string = '';
  limitDescription = 600;
  description: string = '';
  email: string = '';

  constructor(private dialogRef: MatDialogRef<AddInternshipDialogComponent>,
     private companyService: CompanyService, private dialog: MatDialog,
      private alertService: AlertService, private internshipsService: InternshipsService,
    @Inject(MAT_DIALOG_DATA) public availableInternshipData: AvailableInternship, private route: Router,
    private translate: TranslateService) {
    console.log('Dati ricevuti nel dialog:', this.availableInternshipData);
    this.description = this.availableInternshipData.description;
    this.email = this.availableInternshipData.email;
    this.citySearch = this.availableInternshipData.city?.name || '';
    }

  ngOnInit(): void {
    this.companyService.getCountries().subscribe({
      next: (data) => this.countries = data,
      error: (err) => console.error('Errore caricamento paesi:', err)
    });
  }
        
  onCancel(): void {
    this.dialogRef.close();
  }

  loadInternships(): void {
    if(this.availableInternshipData.id){
      this.internshipsService.getAvailableInternshipsById(this.availableInternshipData.id).subscribe({
        next: (data) => {
          
        },
        error: (err) => {
          console.error('Errore nel caricamento dei tirocini:', err);
          /* this.isLoading = false; */
        }
      });
    }

    

  }


  compareCountries(c1: CountryDto, c2: CountryDto): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  compareCities(c1: CityDto, c2: CityDto): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  onCountryChange(): void {
    if (this.availableInternshipData.country) {
      this.availableInternshipData.city = null as any;
      this.citySearch = '';
      this.filteredCities = [];
    } else {
      this.filteredCities = [];
      this.availableInternshipData.city = null as any;
      this.citySearch = '';
    }
  }

  onCityInput(value: string): void {
    if (!this.availableInternshipData.country) {
      this.filteredCities = [];
      return;
    }

    const countryId = this.availableInternshipData.country.id;
    const search = (value || '').trim();

    if (!search) {
      this.filteredCities = [];
      return;
    }

    this.companyService.getCitiesSearch(countryId, search).subscribe({
      next: (data) => {
        this.filteredCities = data;
      },
      error: (err) => {
        console.error('City search error', err);
        this.filteredCities = [];
      }
    });
  }

  onCitySelected(city: CityDto): void {
    this.availableInternshipData.city = city;
    this.citySearch = city.name;
  }

  displayCityFn(item: any): string {
    if (!item) return '';
    return typeof item === 'string' ? item : item.name;
  }

  toggleCancel() {
    this.isEditable = false;
  }

  enableEdit() {
    this.isEditable = true;
    this.citySearch = this.availableInternshipData.city?.name || '';
  }

  autoResizeTextarea(event: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 300) + 'px';
  }

  checkDescriptionLength(): void {
    if (this.description.length > this.limitDescription) {
      alert(this.translate.instant('available-internship-dialog.errors.description-too-long', { limit: this.limitDescription }));
    }
  }

  onSubmit(): void {
    
    const dto = {
      internshipTitle: this.availableInternshipData.title,
      position: this.availableInternshipData.position,
      department: this.availableInternshipData.department,
      country: this.availableInternshipData.country,
      email: this.availableInternshipData.email,
      city: this.availableInternshipData.city,
      visibility: this.availableInternshipData.visibility,
      description : this.description
    };

  

    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
    width: '400px',
    data: { message: this.translate.instant('available-internship-dialog.confirm-save') }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.internshipsService.updateAvailableInternship(this.availableInternshipData.id, dto)
          .subscribe({
            next: (res) => {
              console.log('Internship updated', res);
              this.availableInternshipData = res;  
              this.isEditable = false; 
            },
            error: (err) => { this.checkDescriptionLength(); console.error('Error updating internship', err); }
        });
      }
    });
  }



}
